// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"873":"fb286be6","985":"28375a78"}[chunkId] + ".chunk.css";
};